import { useContext } from 'react';
import { EventContext, type EventContextType } from './eventContextTypes';

export const useEventSelection = (): EventContextType => {
  const context = useContext(EventContext);
  if (!context) {
    throw new Error('useEventSelection must be used within an EventProvider');
  }
  return context;
};

